// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__swPhXOun","error":"Captcha_error__R7O-hkHb"};